<template>
  <div class="form-elements va-row">

      <div class="flex sm4 xs12 offset--sm4">
        <va-card :title="$t('Create watched hashtag')">

          <loading :active.sync="loading" :is-full-page="false"></loading>

          <form @submit.prevent="onsubmit()" class="text-right">
                
                <va-input
                  name = "Hashtag"
                  v-model="payload.hashtag"
                  v-validate="{required: true}"
                  placeholder="Hashtag"
                  :errorMessages="[hashtag_err]"
                  :error="hashtag_has_err"
                />
                
                <va-button color="success" :to="{ name: 'WatchedHashtagList' }" >Back</va-button>
                <va-button color="info" type="submit">Create watched hashtag</va-button>
              
          </form>
        </va-card>
      </div>

  </div>
</template>

<script>

import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import Validation from '@/mixins/ValidationMixin';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: 'hashtag-form',
  mixins: [Validation.Validation],
  components:{Loading},
  data () {
    return {
      loading: false,
      payload: {
        hashtag:""
      }
    }
  },

  computed: {

    ...Validation.mapValidationKeys([
        "hashtag"
    ]),

  },

  methods: {

     ...mapActions({
      save: 'createHashtag'
    }),

    onsubmit () {

      this.loading  = true;
      this.save( this.payload ).then( response => {
          this.$router.push({ name: 'WatchedHashtagList' })
      }).catch( exeption => (this.valErr = exeption,this.loading = false ));


    }
  }
}
</script>

<style>
  .row.row-inside {
    max-width: none;
  }
</style>
